import React from "react";
import TopTags from "./panels/TopTags";

const CommunityPanels = ({ options }) => (
  <>
    <TopTags options={options} />
  </>
);

export default CommunityPanels;
